import * as React from "react";
import { useState, useCallback, useEffect } from "react";
import Header from "./Header";
import AuthStatus from "./AuthStatus";
import DocumentUpload from "./DocumentUpload";
import VoiceAgent from "./VoiceAgent";
import { makeStyles } from "@fluentui/react-components";
import { useAuth } from "../../auth";

interface AppProps {
  title: string;
}

interface UploadedDocument {
  id: string;
  name: string;
  agentId?: string;
}

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const App: React.FC<AppProps> = (props: AppProps) => {
  const styles = useStyles();
  const { isAuthenticated } = useAuth();
  const [uploadedDocument, setUploadedDocument] = useState<UploadedDocument | null>(null);
  const [hasPendingRevisions, setHasPendingRevisions] = useState(false);

  // === Revision Management Logic ===
  const checkRevisions = useCallback(async () => {
    try {
      await Word.run(async (context) => {
        const revisions = context.document.revisions;
        context.load(revisions, "items");
        await context.sync();
        const hasPendingChanges = revisions.items.length > 0;
        setHasPendingRevisions(hasPendingChanges);
      });
    } catch (error) {
      console.error("Error checking revisions:", error);
    }
  }, []);

  const handleAcceptAllRevisions = useCallback(async () => {
    console.log("handleAcceptAllRevisions: Accepting all revisions and turning off tracking.");
    try {
      await Word.run(async (context) => {
        context.document.acceptAllRevisions();
        context.document.changeTrackingMode = Word.ChangeTrackingMode.off;
        await context.sync();
        console.log("All revisions accepted and tracking mode is off.");
      });
      setHasPendingRevisions(false); // Manually update state
    } catch (error) {
      console.error("Error in handleAcceptAllRevisions:", error);
    }
  }, []);

  // La logica di polling e il check iniziale delle revisioni sono stati disabilitati
  // per prevenire problemi di furto del focus, come richiesto dall'utente.
  // La verifica delle revisioni avverrà solo su richiesta esplicita (es. dopo una modifica dell'AI).
  /*
  useEffect(() => {
    if (isAuthenticated) {
      checkRevisions();
      const intervalId = setInterval(checkRevisions, 5000); // Poll every 5 seconds
      return () => clearInterval(intervalId);
    }
    return () => {}; // Add empty cleanup for the other path
  }, [isAuthenticated, checkRevisions]);
  */
  /*
  useEffect(() => {
    if (isAuthenticated) {
      checkRevisions();
    }
  }, [isAuthenticated]);
  */
  // =================================

  const handleDocumentUploaded = useCallback((documentId: string, documentName: string, agentId?: string) => {
    setUploadedDocument({ id: documentId, name: documentName, agentId });
  }, []);

  const handleDocumentReset = useCallback(() => {
    setUploadedDocument(null);
  }, []);

  return (
    <div className={styles.root}>
      <Header logo="assets/logo-filled.png" title={props.title} message="Welcome" />
      <AuthStatus />
      {isAuthenticated && (
        <>
          <DocumentUpload
            onDocumentUploaded={handleDocumentUploaded}
            onDocumentReset={handleDocumentReset}
          />
          <VoiceAgent
            documentId={uploadedDocument?.id}
            documentName={uploadedDocument?.name}
            agentId={uploadedDocument?.agentId}
            checkRevisions={checkRevisions}
          />
        </>
      )}
    </div>
  );
};

export default App;
